import type { SVGProps } from "react";

interface ChartIconProps extends SVGProps<SVGSVGElement> {
  bold?: boolean;
}

export function ChartIcon({ bold = false, ...props }: ChartIconProps) {
  if (bold) {
    return (
      <svg
        width="27"
        height="27"
        viewBox="0 0 27 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.20508 2.20508V24.2564H24.2564"
          stroke="currentColor"
          strokeWidth="1.65385"
        />
        <path
          d="M6.61536 19.8462C11.9218 19.8462 10.3299 4.41028 15.6363 4.41028C20.1468 4.41028 19.3951 13.9442 23.1538 13.9442"
          stroke="currentColor"
          strokeWidth="1.65385"
        />
      </svg>
    );
  }

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.436 6.036v2h2v-2h-2Zm-11.2 24c8.4 0 6.4-18 10-22v-1.6c-5.2 3.6-2.4 22.4-10 22.4v1.2Zm28-10.8c-12.4 0-8.4-10.4-13.6-12.8v1.6c3.2 2.8 1.2 12.4 13.6 12.4v-1.2Zm-31.6-15.6v28.8c0 .8.8 1.6 1.6 1.6h30v-1.2H4.836v-29.2h-1.2Z"
        fill="currentColor"
      />
    </svg>
  );
}